// extracted by mini-css-extract-plugin
export var header = "header-module--header--2ea3u";
export var progress = "header-module--progress--3iaRA";
export var content = "header-module--content--1qWPI";
export var siteTitle = "header-module--site-title--15WAB";
export var siteTitleBefore = "header-module--site-title-before---kSXk";
export var siteTitleAfter = "header-module--site-title-after--y_eBA";
export var link = "header-module--link--3R2_R";